import cn from "classnames";
import Pagination from "components/shared/reactTable/pagination";
import React from "react";

const Item = ({ children, item, current, action, length }) => {
    const cname = cn({
        pagination__item: true,
        "pagination__item--active": item === current,
    });
    return (
        <div className={cname} onClick={() => action(--item * length)}>
            {children}
        </div>
    );
};
class Pg extends Pagination {
    generateItems = (count, current) => {
        return [...new Array(count).keys()]
            .map((item) => ++item)
            .filter((item) => item > current - 3 && item < current + 3);
    };

    render() {
        const { length, start, count, isLoadingCount, children } = this.props;
        const pcount = Math.ceil(count / length);
        const current = Math.floor((length + start) / length);
        const addProps = { pcount, current };
        return (
            !isLoadingCount &&
            pcount > 0 && (
                <div className="pagination">
                    {children}
                    <div className="pagination__pages">
                        {current !== 1 && (
                            <Item {...addProps} {...this.props} item={1}>
                                &#171;
                            </Item>
                        )}
                        {this.generateItems(pcount, current).map((item) => (
                            <Item key={item} {...addProps} {...this.props} item={item}>
                                {item}
                            </Item>
                        ))}
                        {current !== pcount && (
                            <Item {...addProps} {...this.props} item={pcount}>
                                &#187;
                            </Item>
                        )}
                    </div>
                    <div className="pagination__page-size-container">{this.renderPageSizeOptions()}</div>
                </div>
            )
        );
    }
}

export default Pg;
